/* eslint-disable no-console */
import { Component, Prop, Ref} from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class GiftcardRecipientForm extends ThemeComponent {
    @Ref() giftCheckbox!: HTMLInputElement;
    @Ref() recipientFields!: HTMLInputElement;

    init() {
        // Init element click event listener
        this.$listen(this.giftCheckbox, 'click', () => {
            this.toggleAccordion();
        });
    }

    toggleAccordion() {
        this.recipientFields.classList.toggle('visually-hidden');
    }

}
